import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import Differentiators from "@/components/landing/Differentiators";
import Comparison from "@/components/landing/Comparison";
import CaseStudy from "@/components/landing/CaseStudy";
import FAQ from "@/components/landing/FAQ";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[#0B0D12] text-[#EDEDED] selection:bg-[#FF4500] selection:text-[#0B0D12] overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <HowItWorks />
      <Differentiators />
      <Comparison />
      <CaseStudy />
      <FAQ />
      <CTASection />
      <Footer />
    </main>
  );
}
